import type { ProgramSlideLayoutSubsetV1 } from '../types/evaluationPlanSheetCanvas';
import {
  sheetLayoutSubsetToSlideLayout,
  slideLayoutToSheetLayoutSubset,
} from '../types/learningContentWorksheetCanvas';
import type { ProgramSlideLayoutV1 } from '../types/programContentSlideCanvas';
import { parseSlideLayoutJson } from '../types/programContentSlideCanvas';

export const PROGRAM_WORKSHEET_REGISTRY_NAME_MAX_LENGTH = 12;
export const PROGRAM_WORKSHEET_REGISTERED_PAGE_MAX_COUNT = 20;

export function limitProgramWorksheetRegistryNameDraft(raw: string): string {
  return Array.from(raw).slice(0, PROGRAM_WORKSHEET_REGISTRY_NAME_MAX_LENGTH).join('');
}

export function normalizeProgramWorksheetRegistryName(raw: unknown, fallback: string): string {
  const trimmed = String(raw ?? '').trim();
  const base = trimmed || fallback;
  return limitProgramWorksheetRegistryNameDraft(base);
}

export function programWorksheetRegistryFallbackName(index: number): string {
  return String(index + 1);
}

function newElementId(): string {
  const id = globalThis.crypto?.randomUUID?.();
  if (id) return id;
  return `ws-tpl-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function remapIds<T extends { id: string }>(items: T[] | undefined): T[] {
  return (items ?? []).map((item) => ({ ...item, id: newElementId() }));
}

/** 활동지 레이아웃을 현재 페이지에 붙일 때 요소 id 충돌을 피한다. */
export function cloneWorksheetTemplateLayoutWithNewIds(
  layout: ProgramSlideLayoutSubsetV1 | ProgramSlideLayoutV1
): ProgramSlideLayoutSubsetV1 {
  const asSlide =
    'v' in layout && (layout as ProgramSlideLayoutV1).v === 1
      ? parseSlideLayoutJson(layout)
      : sheetLayoutSubsetToSlideLayout(layout as ProgramSlideLayoutSubsetV1);
  const remapped: ProgramSlideLayoutV1 = {
    ...asSlide,
    appliedLayoutTemplateId: undefined,
    boxes: remapIds(asSlide.boxes),
    shapes: remapIds(asSlide.shapes),
    polylines: remapIds(asSlide.polylines),
    tables: remapIds(asSlide.tables),
    images: remapIds(asSlide.images),
    clipboardImages: remapIds(asSlide.clipboardImages),
    scanImages: remapIds(asSlide.scanImages),
    buttons: remapIds(asSlide.buttons),
    videos: remapIds(asSlide.videos),
    webpages: remapIds(asSlide.webpages),
    quizzes: remapIds(asSlide.quizzes),
    quizChoiceSets: remapIds(asSlide.quizChoiceSets),
    quizChoiceOptions: remapIds(asSlide.quizChoiceOptions),
  };
  return slideLayoutToSheetLayoutSubset(remapped);
}
